function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#ED1C24"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.63 2.71a.47.47 0 11.66.66l-7.92 7.92a.47.47 0 01-.66-.66l7.92-7.92z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M11.41 3.5L3.5 11.4a.64.64 0 11-.9-.9l7.92-7.92a.64.64 0 01.9.9zm-.12-.79a.47.47 0 00-.66 0l-7.92 7.92a.47.47 0 10.66.66l7.92-7.92a.47.47 0 000-.66z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.29 10.63a.47.47 0 11-.66.66L2.71 3.37a.47.47 0 01.66-.66l7.92 7.92z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M10.5 11.41L2.6 3.5a.64.64 0 01.9-.9l7.92 7.92a.64.64 0 01-.9.9zm.79-.12a.47.47 0 000-.66L3.37 2.71a.47.47 0 10-.66.66l7.92 7.92c.18.18.48.18.66 0z",
  clipRule: "evenodd"
}));

function SvgDeleteX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteX);
export default __webpack_public_path__ + "static/media/delete-x.779cbd60.svg";
export { ForwardRef as ReactComponent };